// quadTransform — reine 2D-Geometrie für die Quad-Darstellung (Editor + Frontend-Anzeige).
//
// EIN Ort für die Rotations- und Homographie-Mathematik (CSS `matrix3d`), geteilt zwischen dem interaktiven
// OverlayEditor und dem read-only Frontend-Renderer. Keine google-Abhängigkeit — arbeitet auf reinen {x,y}-Pixeln.

// Punkt p um Zentrum c um `deg` Grad drehen (Bildschirm-Pixelraum).
export function rotatePoint(p, c, deg) {
    const rad = deg * Math.PI / 180, cos = Math.cos(rad), sin = Math.sin(rad);
    const dx = p.x - c.x, dy = p.y - c.y;
    return { x: c.x + dx * cos - dy * sin, y: c.y + dx * sin + dy * cos };
}

// --- 2D-Projektion (Homographie): Quell-Rechteck → Ziel-Quad → CSS matrix3d (Standard-„general 2D projection") ---

function adj(m) {
    return [
        m[4] * m[8] - m[5] * m[7], m[2] * m[7] - m[1] * m[8], m[1] * m[5] - m[2] * m[4],
        m[5] * m[6] - m[3] * m[8], m[0] * m[8] - m[2] * m[6], m[2] * m[3] - m[0] * m[5],
        m[3] * m[7] - m[4] * m[6], m[1] * m[6] - m[0] * m[7], m[0] * m[4] - m[1] * m[3]
    ];
}
function multmm(a, b) {
    const c = [];
    for (let i = 0; i < 3; i++) {
        for (let j = 0; j < 3; j++) {
            let s = 0;
            for (let k = 0; k < 3; k++) { s += a[3 * i + k] * b[3 * k + j]; }
            c[3 * i + j] = s;
        }
    }
    return c;
}
function multmv(m, v) {
    return [
        m[0] * v[0] + m[1] * v[1] + m[2] * v[2],
        m[3] * v[0] + m[4] * v[1] + m[5] * v[2],
        m[6] * v[0] + m[7] * v[1] + m[8] * v[2]
    ];
}
function basisToPoints(x1, y1, x2, y2, x3, y3, x4, y4) {
    const m = [x1, x2, x3, y1, y2, y3, 1, 1, 1];
    const v = multmv(adj(m), [x4, y4, 1]);
    return multmm(m, [v[0], 0, 0, 0, v[1], 0, 0, 0, v[2]]);
}
// Quell-Rechteck (0,0)/(w,0)/(0,h)/(w,h) → Ziel-Quad d {nw,ne,sw,se} (Reihenfolge TL,TR,BL,BR). Liefert matrix3d-String.
export function matrix3dForQuad(w, h, d) {
    const s = basisToPoints(0, 0, w, 0, 0, h, w, h);
    const t = basisToPoints(d.nw.x, d.nw.y, d.ne.x, d.ne.y, d.sw.x, d.sw.y, d.se.x, d.se.y);
    const H = multmm(t, adj(s));
    for (let i = 0; i < 9; i++) { H[i] = H[i] / H[8]; }
    const m = [
        H[0], H[3], 0, H[6],
        H[1], H[4], 0, H[7],
        0, 0, 1, 0,
        H[2], H[5], 0, H[8]
    ];
    return 'matrix3d(' + m.join(',') + ')';
}
